import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { useState } from 'react';

/**
 * Builds out the button props to hide the bigger boat mobile blocking screen.
 * Intended only to be used internally at MR CS team and not with real customers.
 */
export default function useMobileBlockerProps() {
  const { ecmMobileBlockCloserEnabled } = useFeatureEnabled(FEATURE_FLAGS.ecmMobileBlockCloser);
  const [isScreenHidden, setIsScreenHidden] = useState(false);

  const buttonProps = {};

  if (ecmMobileBlockCloserEnabled) {
    buttonProps.buttonText = 'Continue to Site Anyway';
    buttonProps.onClick = () => {
      setIsScreenHidden(true);
    };
  }

  // instantly turn the screen back on if FF is disabled
  const isScreenReallyHidden = Boolean(ecmMobileBlockCloserEnabled && isScreenHidden);

  return {
    isScreenHidden: isScreenReallyHidden,
    button: buttonProps,
  };
}
